import $ from "jquery";
import throttle from "lodash/throttle";
import util from "../util";

/**
 * Handles displaying a warning icon when certain elements aren't
 * visible inside the viewport. You give any elements on the page
 * the '.js-warning' class to mark them as warnings.
 *
 * @param $el - The jQuery el for the warning icon
 */
function Warning($el) {
    let warnings = [];

    function calculate() {
        const $warnings = $(".js-warning");
        if ($warnings.length === 0) {
            warnings = [];
            return;
        }

        const currentScroll = document.body.scrollTop;

        warnings = [];
        $warnings.each((idx, el) => {
            const $w = $(el);
            warnings.push({
                $el: $w,
                offset: $w.offset().top + currentScroll,
            });
        });

        warnings.sort((a, b) => (a.offset >= b.offset ? 1 : -1));
    }

    function getWarningsBelowViewport() {
        const top = document.body.scrollTop + window.innerHeight - 100; // padding
        return warnings.filter((w) => w.offset > top);
    }

    const checkWarnings = throttle(() => {
        const below = getWarningsBelowViewport();

        if (below.length > 0) {
            $el.fadeIn("fast");
        } else {
            $el.fadeOut("fast");
        }
    }, 100);

    function init() {
        checkWarnings();
        $("body").on("scroll", checkWarnings);
    }

    calculate();
    init();

    function goToNext(event) {
        event.preventDefault();

        if (warnings.length === 0) {
            return;
        }

        const below = getWarningsBelowViewport();
        if (below.length > 0) {
            util.scrollTo(below[0].$el);
        }
    }

    $el.on("click", goToNext);

    return {
        recalculate: calculate,

        scrollToFirst() {
            if (warnings.length > 0) {
                util.scrollTo(warnings[0].$el);
            }
        },

        stop() {
            $("body").off("scroll", checkWarnings);
            $el.off("click", goToNext);
        },
    };
}

export default Warning;
